import Root from "./Root";
import Icon from "./Icon";
import Text from "./Text";
import { Priority, Variant } from "./Sticker.types";
import type { RootProps } from "./Root";
import type { IconProps } from "./Icon";

// Re-export original types with Sticker prefix
export { Priority as StickerPriority, Variant as StickerVariant };

// Export component prop types with Sticker prefix
export type StickerRootProps = RootProps;
export type StickerIconProps = IconProps;
export type StickerTextProps = React.ComponentProps<typeof Text>;

/**
 * Sticker component for notifications and alerts
 *
 * @example
 * ```jsx
 * <Sticker.Root priority="information">
 *   <Sticker.Icon priority="information" />
 *   <Sticker.Text>This is a notification</Sticker.Text>
 * </Sticker.Root>
 * ```
 */
export const Sticker = {
  Root,
  Icon,
  Text
};
